import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { getScrollTriggerRefreshPriority } from './scroll-trigger-priority'

gsap.registerPlugin(ScrollTrigger)

let horizontalScrollCleanup = null

const getHorizontalDistance = (wrap, containerWidth) =>
    Math.max(0, wrap.scrollWidth - containerWidth)

const refreshWhenLayoutSettles = (root) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => ScrollTrigger.refresh())
    })

    document.fonts?.ready?.then(() => ScrollTrigger.refresh())

    root.querySelectorAll('img').forEach((image) => {
        if (image.complete) return

        image.addEventListener('load', () => ScrollTrigger.refresh(), {
            once: true
        })
    })
}

export function initHorizontalScrolling(root = document) {
    horizontalScrollCleanup?.()
    horizontalScrollCleanup = null

    const mm = gsap.matchMedia()
    horizontalScrollCleanup = () => mm.revert()

    mm.add(
        {
            isMobile: '(max-width:479px)',
            isMobileLandscape: '(max-width:767px)',
            isTablet: '(max-width:991px)',
            isDesktop: '(min-width:992px)'
        },
        (context) => {
            const { isMobile, isMobileLandscape, isTablet } = context.conditions

            const ctx = gsap.context(() => {
                const wrappers = root.querySelectorAll(
                    '[data-horizontal-scroll-wrap]'
                )

                if (!wrappers.length) return

                wrappers.forEach((wrap) => {
                    // optional disable logic per breakpoint
                    const disable = wrap.getAttribute(
                        'data-horizontal-scroll-disable'
                    )
                    if (
                        (disable === 'mobile' && isMobile) ||
                        (disable === 'mobileLandscape' && isMobileLandscape) ||
                        (disable === 'tablet' && isTablet)
                    ) {
                        return // skip this wrapper on specified breakpoint
                    }
                    const container = wrap.closest('.container')
                    const pin = wrap.closest('[data-horizontal-scroll-pin]')

                    if (!container || !pin) return

                    // console.log(container.offsetWidth)
                    // console.log(window.innerWidth)
                    const panels = gsap.utils.toArray(
                        '[data-horizontal-scroll-panel]',
                        wrap
                    )

                    if (panels.length < 2) return

                    const getContainerWidth = () => {
                        const style = getComputedStyle(container)

                        return (
                            container.clientWidth -
                            parseFloat(style.paddingLeft) -
                            parseFloat(style.paddingRight)
                        )
                    }
                    const getDistance = () =>
                        getHorizontalDistance(wrap, getContainerWidth())

                    gsap.to(panels, {
                        x: () => -getDistance(),
                        ease: 'none',
                        scrollTrigger: {
                            refreshPriority: getScrollTriggerRefreshPriority(
                                wrap,
                                10
                            ),
                            trigger: pin,
                            start: 'top top',
                            end: () => '+=' + getDistance(),
                            scrub: true,
                            pin: pin,
                            invalidateOnRefresh: true,
                            markers: false
                        }
                    })
                })

                refreshWhenLayoutSettles(root)
            })

            return () => ctx.revert()
        }
    )
}
